module.exports = __webpack_public_path__ + "img/stop_btn.3bc99544.png";